// extracted by mini-css-extract-plugin
module.exports = {"ctoButton":"CellularCapability_ctoButton__YBLAs","noHoverBg":"CellularCapability_noHoverBg__3Z5mj"};